import { useState } from 'react';
import type { ArtistType } from '../../types/ArtistType';

interface ArtistCardProps {
  artist: ArtistType;
  selected: boolean;
  setSelectedArtist: (artistId: string) => void;
}

export default function ArtistCard({
  artist,
  selected,
  setSelectedArtist
}: ArtistCardProps): JSX.Element {
  const [applyAnimation, setApplyAnimation] = useState<boolean>(false);

  const getClassName = (): string => {
    if (!applyAnimation) return selected ? 'no-animation' : 'fade-out';
    return selected ? 'fade-in' : 'fade-out';
  };

  const handleClick = (): void => {
    if (!applyAnimation) setApplyAnimation(true);
    setSelectedArtist(artist.artistId?.toString() || '');
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="relative w-[64px] h-[108px]"
      id={`artistIcon_${artist.artistId}`}
    >
      <div className={getClassName()} style={{ position: 'absolute', top: 0, left: 0, zIndex: 1 }}>
        <svg
          width="66"
          height="66"
          role="img"
          aria-labelledby={`selection-indicator-${artist.artistId}`}
        >
          <title id={`selection-indicator-${artist.artistId}`}>
            {selected ? '선택됨' : '선택 안됨'}
          </title>
          <circle
            className="stroke-onSecondary-light dark:stroke-onSecondary-dark"
            cx="33"
            cy="33"
            r="28"
            fill="none"
            strokeWidth="1.5"
          />
        </svg>
      </div>

      <div className="w-[64px] h-[108px] mx-[7px] mt-[7px]">
        <img
          className="border-[1px] border-placeholder-light dark:border-placeholder-dark w-[52px] h-[52px] rounded-full object-cover"
          src={artist.thumbnailUrl || ''}
          alt={artist.shortName || artist.name}
        />
        <div
          className={`text-center py-[14px] text-[14px] font-semibold leading-[17px] ml-[-12px] line-clamp-2 whitespace-pre-line ${
            selected
              ? 'text-onSecondary-light dark:text-onSecondary-dark'
              : 'text-main-light-2 dark:text-main-dark-2'
          }`}
        >
          {artist.shortName || artist.name}
        </div>
      </div>
    </button>
  );
}
